import React, { useEffect } from 'react';

const ImageOpt = ({ imgData, imgAlt, imgLoad, imgClass, width, height, className }) => {
  useEffect(() => {
    imgCdn();
  }, []);

  const imgCdn = (imgData, width, height) => {
    const img = `https://wsrv.nl/?url=${imgData}&w=${width}&h=${height}&output=webp&q=80&dpr=1.3`;
    return img;
  };

  return (
    <>
      <img
        src={imgCdn(imgData, width, height)}
        className={`${className} ${imgClass}`}
        width={width}
        height={height}
        alt={imgAlt}
        loading={imgLoad || 'lazy'}
      />
    </>
  );
};

export default ImageOpt;
